import * as React from 'react';

interface StatStripXpress2UsageStepsProps {
    onComplete: () => void;
}

export const StatStripXpress2UsageSteps = ({ onComplete }: StatStripXpress2UsageStepsProps) => {
    return (
        <>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="text-primary">Device Setup Complete</h2>
                    </div>
                    <div className="col-md-12">
                        <ol className="posh-list">
                            <li>Remove the data cable from the device and from the PC</li>
                            <li>The device is now ready for use, please refer to the instructions provided with the device</li>
                        </ol>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={onComplete}>Complete</button>
            </div>
        </>
    );
}
